import { createApiRequest } from "../common";
import { UpdateOrgMemberRequestContent, UpdateOrgMemberResponseContent } from '@equaliq/api-model';

export const updateOrgMemberApi = async (request: UpdateOrgMemberRequestContent): Promise<UpdateOrgMemberResponseContent> => {
  const apiRequest = createApiRequest<UpdateOrgMemberResponseContent>('post', '/orgs/updateMember');
  return apiRequest(request);
};
